"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitOme = void 0;
require('slick-carousel');
//require('scrollmagic');
//import ScrollMagic from "scrollmagic";
let TweenMax = require('gsap');
let ScrollMagic = require('scrollmagic');
//require('ScrollMagicGSAP');
// config
const teamMainPageUrl = '/o.me/team/team-member/';
function InitOme() {
    const omeImagesBlock = () => {
        // init controller
        const controller = new ScrollMagic.Controller();
        // Scene2 Handler
        const scene1 = new ScrollMagic.Scene({
            triggerElement: "#ome-images-1-tr",
            //duration: 190, // pin the element for a total of 400px
            duration: 130,
            offset: 150
            //duration: $(window).height() / 2 // pin the element for a total of 400px
        })
            .setPin("#ome-images-2"); // the element we want to pin
        // Scene3 Handler
        const scene2 = new ScrollMagic.Scene({
            triggerElement: "#ome-images-1-tr",
            //duration: 190, // pin the element for a total of 400px
            duration: 130,
            offset: 150
            //duration: $(window).height() / 2 // pin the element for a total of 400px
        })
            .setPin("#ome-text-1"); // the element we want to pin
        // Add Scenes to ScrollMagic Controller
        controller.addScene([
            scene1,
            scene2
        ]);
    };
    const isMobile = () => {
        return (jQuery(window).innerWidth() < 992);
    };
    const isMobileVideo = () => {
        return (jQuery(window).innerWidth() < 641);
    };
    const initContentPageSlider = () => {
        jQuery('body.ome.ContentPage .o-slick-container').attr('data-numberofslides', '1');
    };
    const mobileSubNaviBtnHandler = () => {
        let lastScrollTop = 0;
        let isOpen = false;
        const naviElemHeight = jQuery('.subpage-navi-button-wrapper').height();
        //console.log('naviElemHeight', naviElemHeight);
        $(window).scroll(function () {
            if (isMobile) {
                if (!jQuery('.header-wrapper').is(":visible")) {
                    const st = $(this).scrollTop();
                    if (st > naviElemHeight) {
                        if (st > ($(document).height() - ($(window).height() * 1.2))) {
                            if (!isOpen) {
                                jQuery('.subpage-navi-button-wrapper').slideUp();
                                jQuery('.navi-button').slideUp();
                            }
                        }
                        else {
                            if (st > lastScrollTop) {
                                jQuery('.subpage-navi-button-wrapper').slideUp();
                                jQuery('.navi-button').slideUp();
                                isOpen = false;
                            }
                            else {
                                jQuery('.subpage-navi-button-wrapper').slideDown();
                                jQuery('.navi-button').slideDown();
                                isOpen = true;
                            }
                        }
                        lastScrollTop = st;
                    }
                }
            }
        });
    };
    const initVideo = () => {
        if ($('.o-hero-slide__video-ome').length > 0) {
            if ($(window).width() < 992 && $('.o-hero-slide__video-ome').attr('data-src-mobile') != "") {
                $('.o-hero-slide__video-ome').children('source').attr('src', $('.o-hero-slide__video-ome').attr('data-src-mobile'));
            }
            else {
                $('.o-hero-slide__video-ome').children('source').attr('src', $('.o-hero-slide__video-ome').attr('data-src-desktop'));
            }
            //let vPlayer = $('.o-hero-slide__video')[0] as HTMLVideoElement; //Might be better
            let vPlayer = document.getElementById('hero-video-ome');
            vPlayer.load();
        }
        ;
    };
    const initMobileVideo = () => {
        const screenWidth = jQuery(window).innerWidth();
        //const screenHeight = jQuery(window).innerHeight();
        //console.log('screenWidth', screenWidth);
        //console.log('screenHeight', screenHeight);
        jQuery('body.ome.StartPage .o-hero-slide__video-ome').width(screenWidth);
        //jQuery('body.ome.StartPage .o-hero-slide__video').height(screenHeight);
    };
    $(document).ready(function () {
        // init
        if (jQuery('body.ome.StartPage .o-hero-slide__video-ome').length) {
            initVideo();
            if (isMobile()) {
                initMobileVideo();
            }
        }
        // Hide Hartwall default footer
        $('.content-wrapper').addClass('u-hide-footer');
        // Mobile Navigation
        jQuery('#navi-toggle, #subpage-navi-toggle').click(function () {
            jQuery('.header-wrapper').slideToggle();
            jQuery('#navi-toggle, #subpage-navi-toggle').toggleClass('open');
        });
        //console.log('jQuery(body.ome.StartPage).length', jQuery('body.ome.StartPage').length);
        // Don't execute on StartPage
        if (jQuery('body.ome.StartPage').length === 0) {
            mobileSubNaviBtnHandler();
        }
        if (jQuery('.ome-images-wrapper').length && !isMobile()) {
            omeImagesBlock();
        }
        // display ContentPage Slider Block if exists
        // Team main page
        if (jQuery('body.ContentPage .o-slick-container, body.ContentPageWithStartPageViews .o-slick-container').length) {
            /* Read cItemIdx url parameter and show slide with parameter value */
            let cItemIdx = 0;
            const searchParams = new URLSearchParams(window.location.search);
            if (searchParams.has('cItemIdx')) {
                cItemIdx = eval(searchParams.get('cItemIdx'));
            }
            initContentPageSlider();
            setTimeout(() => {
                //const parent = jQuery('body.ContentPage');
                const parent = jQuery('body.ContentPageWithStartPageViews');
                window.setSlide(cItemIdx, parent);
                jQuery('.o-slick-container').css('visibility', 'visible');
            }, 300);
        }
        //console.log('jQuery(body.StartPage).length', jQuery('body.StartPage').length);
        // display StartPage Slider Block if exists
        if (jQuery('body.StartPage .Coreweb-js-slider').length) {
            /* Rewrite urls to point to the Team Main page with cItemIdx parameter */
            setTimeout(() => {
                jQuery('.Coreweb-js-slider .slick-slide').each(function () {
                    const slickIdx = jQuery(this).data('slick-index');
                    const linkElem = jQuery(this).children('div').children('a');
                    jQuery(linkElem).attr('href', teamMainPageUrl + '?cItemIdx=' + slickIdx);
                    //console.log('slickIdx', slickIdx);
                });
            }, 200);
            setTimeout(() => {
                jQuery('.o-slick-container').css('visibility', 'visible');
            }, 300);
        }
        /* PageListBlock url's */
        if (jQuery('body.ContentPage .pagelistblock').length) {
            /* Rewrite urls to point to the Team Main page with cItemIdx parameter */
            jQuery('.pagelistblock .pagelist-row > div').each(function (idx) {
                const linkElem = jQuery(this).children('a');
                jQuery(linkElem).attr('href', teamMainPageUrl + '?cItemIdx=' + idx);
            });
        }
        // Product Carousel Modal
        //$(".popup-open").on("click", function () {
        //    console.log('clicked');
        //    $(".popup-overlay, .popup-content").addClass("active");
        //    $("body").addClass("popup-view");
        //});
        $(".popup-close").on("click", function () {
            $(".popup-overlay, .popup-content").removeClass("active");
            $("body").removeClass("popup-view");
        });
    });
    // Product carousel
    window.showPopup = (infoId) => {
        if (!isMobile()) {
            let popupHeight = jQuery('.slick-slider').height();
            jQuery('.popup-overlay').height(popupHeight);
        }
        else {
            jQuery('.popup-overlay').height('auto');
        }
        $("body").addClass("popup-view");
        jQuery(".popup-overlay, .popup-content").removeClass("active");
        jQuery('.popup-overlay, #popup-content-' + infoId).addClass("active");
    };
}
exports.InitOme = InitOme;
